"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var types_1 = require("../../types");
// WORKAROUND:
// It would be better to reduce the opacity of these colors to allow some of the
// form background to bleed through & make changing the brightness simpler,
// however there is an obscure bug in safari that means you cannot use opacity
// inside an SVG foreignObject element. See link:
// https://bugs.webkit.org/show_bug.cgi?id=23113
var useStyles = styles_1.makeStyles({
    disabled: {
        backgroundColor: '#fff',
    },
    error: {
        backgroundColor: '#FFDCDC',
        '&:focus-within': {
            backgroundColor: '#FFB8B8',
        },
    },
    optional: {
        backgroundColor: '#AEF8FF',
        '&:focus-within': {
            backgroundColor: '#5CF5FF',
        },
    },
    required: {
        backgroundColor: '#FBFFAE',
        '&:focus-within': {
            backgroundColor: '#FBFF5C',
        },
    },
    success: {
        backgroundColor: '#C7FFAE',
        '&:focus-within': {
            backgroundColor: '#90FF5C',
        },
    },
});
var useStatusClass = function (status) {
    var classes = useStyles();
    switch (status) {
        case types_1.PageInputStatus.Disabled:
            return classes.disabled;
        case types_1.PageInputStatus.Error:
            return classes.error;
        case types_1.PageInputStatus.Optional:
            return classes.optional;
        case types_1.PageInputStatus.Required:
            return classes.required;
        case types_1.PageInputStatus.Success:
            return classes.success;
    }
};
exports.default = useStatusClass;
//# sourceMappingURL=useStatusClass.js.map